export default __webpack_public_path__ + "static/media/Image-Slider-02.62610623.jpg";